import axios from "axios";
import http from "@/api/http/http";

export default {
  list() {
    return axios.get(`${process.env.VUE_APP_API}/admin/menus`, http.setHeaders())
  },
  create(params) {
    return axios.post(`${process.env.VUE_APP_API}/admin/menus`, params, http.setHeaders())
  },
  update(id, params) {
    return axios.put(`${process.env.VUE_APP_API}/admin/menus/${id}`, params, http.setHeaders())
  },
  delete(id) {
    return axios.delete(`${process.env.VUE_APP_API}/admin/menus/${id}`, http.setHeaders())
  },
}
